import { render, staticRenderFns } from "./OEditKlasse.vue?vue&type=template&id=ad109262&"
import script from "./OEditKlasse.vue?vue&type=script&lang=js&"
export * from "./OEditKlasse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports